// extracted by mini-css-extract-plugin
module.exports = {"Container":"Index_Container__3FdPt"};